import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=d4c8aca0&"
import script from "./NewPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./NewPasswordPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports